const neckNodes = [

        {label:"Side",
        controlType:"radio button",
        options:["Bilateral","Right", "Left", ]
        },

        {label:"Site(s)",
        controlType:"checkbox group",
        options:["Supraclavicular", "Submandibular", "Anterior triangle", "Posterior triangle"]
        },

        {
        label:"Max Size (cm)",
        controlType:"text",
        options:[]
        },
        
        { 
        label:"Consistency:",
        controlType:"radio button",
        options:["Hard", "Soft"]
        },
    
        { 
        label:"Shape:",
        controlType:"radio button",
        options:["Smooth", "Irregular"]
        },
    
        { 
        label:"Pain:",
        controlType:"radio button",
        options:["Painful", "Painless"]
        },
    
        { 
        label:"Tenderness:",
        controlType:"radio button",
        options:["Tender", "Non-tender"]
        },
    
        { 
        label:"Present for several:",
        controlType:"radio button",
        options:["Days", "Weeks","Months","Years"]
        }
        
    ]
    
    export default neckNodes
